// extracted by mini-css-extract-plugin
export default {"largestMobileScreen":"767px","largestMobileScreenPlusOne":"768px"};